import { Modal } from 'react-bootstrap';
import { t } from "../locale";

interface KDocAnalyzeProps {
    show: boolean;
    fields: string[]|undefined;
    onClose: () => void;
}

const KDocAnalyzeModal: React.FC<KDocAnalyzeProps> = ({ show, fields, onClose }) => {
    return (
        <Modal show={show} onHide={onClose} centered dialogClassName="modal-m modern-modal">
            <Modal.Header closeButton>
                <Modal.Title>{t('documentCheck')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
                {fields &&
                    <>
                        <div className="mb-3">
                            <div className="d-flex align-items-center mb-2">
                                <i className="bi bi-exclamation-triangle-fill text-warning me-2 fs-5"></i>
                                <h6 className="mb-0 text-muted">{t('dataNotMatch')}</h6>
                            </div>
                            <p className="text-muted small">
                                {t('reviewFields')}
                            </p>
                        </div><div className="border rounded bg-light p-3">
                            {fields.length > 0 ? (
                                <ul className="list-unstyled mb-0">
                                    {fields.map((field, index) => (
                                        <li key={index} className="d-flex align-items-center mb-2">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-capitalize text-dark fw-medium">{t(field)}</span>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className="text-muted">{t('All fields are valid.')}</div>
                            )}
                        </div>
                    </>
                }
                {!fields &&
                    <>
                        <div className="mb-3">
                            <div className="d-flex align-items-center mb-2">
                                <i className="bi bi-camera-fill text-primary me-2 fs-5"></i>
                                <h6 className="mb-0 text-muted">{t('documentNotValid')}</h6>
                            </div>
                            <p className="text-muted small">
                                {t('retakePhoto')}
                            </p>
                        </div><div className="text-center">
                            <button className="btn btn-outline-primary" onClick={onClose}>
                                <i className="bi bi-arrow-repeat me-1"></i> {t('retakeButton')}
                            </button>
                        </div>
                    </>
                }
            </Modal.Body>




        </Modal>
    )
}

export default KDocAnalyzeModal;